var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetractIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833333 0H7.88333L7.885 1.66667H2.845L8.47333 7.29667L7.295 8.475L1.66667 2.84667V7.88333H0V0.833333V0H0.833333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 10V4.16667V1.66667H15.8333H12.1167V0H15.8333H20V4.16667V15.8333V20H15.8333H4.16667H0V15.8333V12.1167H1.66667V15.8333V18.3333H4.16667H10V12.95V10H12.95H18.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetractIcon);
export default __webpack_public_path__ + "static/media/retract-icon.6866da786cecf465aacbb0a2a81c9dfc.svg";
export { ForwardRef as ReactComponent };